export const ComponentConstants = {
    ENDORSEMENTS: '72fd27fb-aa35-4bca-a70e-01d8fd0d3946',
    HELP: '59a6804-f970-4f45-96ba-071bd3a36c4d',
    COMPETENCIES: '02f79894-2261-4d73-88d6-085c0ce58f2c',
    LOOKUPS: '9695fac5-6d33-499e-aba9-2067c62ce270',
    FIREARMS: 'cec3e038-fb39-4dba-8b8b-2100dc294680',
    SCORES: '9e2833c4-85c6-4195-b573-210fff9d5521',
    GRADINGS: '634d0e85-8cdc-46b3-8586-25be81e53a72',
    QUESTIONS: '13d61379-b5aa-4042-be2f-337b4619edd2',
    SLIDER: '476a0a1a-b89a-4f80-b5e7-34699d302379',
    FARMS: '6da3e771-0db0-40b3-9392-35b315e6739f',
    WORK: 'f32a2705-de40-4351-a0a8-3d08d052e47c',
    RECONS_UNALLOCATED: '06a9aaca-d286-41a0-8dc8-441554c025a4',
    RECONS_CONFIRMATIONS: 'de913459-66a0-457e-bef0-49412e64a0b1',
    NOTES: '8ef7f3c5-0dd5-4cc2-b05a-50bb40b642cf',
    TARGETS: '047e3c9f-2149-4477-bb3d-5ea05776bbb3',
    RANGES: '81d6a65a-f704-4c54-a730-6b20cbf9e027',
    RECON_TRANSACTIONS: '6caefd28-9da1-4715-bb99-6f56c180a5e9',
    DEDICATED_COURSES: 'fbd08d61-0530-422f-b27d-8c009281774e',
    INVOICES: 'fb3cd9cd-04de-436b-8637-8dfdf14a1eef',
    COMPETITION: '1287e7c9-33e3-47d0-8ebe-93d40cf7f96d',
    EXERCISES: '2ec44611-ce0c-42b7-aa39-a2923307a443',
    ACTIVITIES: 'f28c03c4-3da1-4998-a55d-a9c0a2a05e3a',
    MESSAGES: 'eb1dae0c-97d0-4f41-b92a-b318c6a1aa79',
    ENQUIRIES: 'ed03b88b-ce09-4ba6-be69-b5116534bad6',
    FILES: 'c5d25743-f9d0-4c30-95d9-b5fdd7c65b1c',
    BOOKMARKS: '6a94221e-a38d-4994-837e-b8eea554d66f',
    RECON_LINKS: 'a689c323-005c-4a48-9621-b8f4165e85ec',
    ADMIN: '271b2994-20c4-439f-b556-bf6f69ee56cf',
    DIRECTORY: 'f016198a-e693-46dd-8bf0-c0f9cf930c5c',
    EMAILS: 'c7158e5-bdd3-4dfc-b5c6-c4c7754615f3',
    REPLY_TEMPLATES: '371d1b1b-4369-45d7-9a5b-cc21e8e1af49',
    RENEWALS: '6c7e01bd-06e8-4943-848e-cfcb2ead225c',
    NEWS: '18e6c520-8b5c-41fd-ab88-d41244b1d418',
    PAGES: '97ffe57b-a313-450e-a945-d70953377473',
    MEMBERS: '164f249b-f1e5-48ea-9307-dbfde071c62a',
    CCIC: 'ca8da4bb-485f-4fee-a4c9-ddd1ed534e64',
    DOCUMENTS: '86209de-a926-4f60-bc38-e3cbec724096',
    RPL: '6777a77b-9d5a-40cf-9438-e8e6956bcb46',
    NEWSLETTERS: '11bb0205-6c9a-43dc-b1ef-ffe186e44dca'
}

// Maps ComponentConstants GUIDs to blob storage container names for proof of payment files
export const ComponentContainerMap: Record<string, string> = {
    [ComponentConstants.RPL]: 'files',
    [ComponentConstants.DEDICATED_COURSES]: 'files',
    [ComponentConstants.RENEWALS]: 'files',
    [ComponentConstants.MEMBERS]: 'files',
    [ComponentConstants.COMPETITION]: 'files',
};

/**
 * Gets the blob storage container name for a given component ID
 * @param componentId - The component GUID from ComponentConstants
 * @returns The container name for proof of payment files
 * @throws Error if componentId is not mapped to a container
 */
export const getContainerName = (componentId: string): string => {
    const containerName = ComponentContainerMap[componentId];
    if (!containerName) {
        throw new Error(`No container mapping found for component ID: ${componentId}`);
    }
    return containerName;
};